module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.layouts.gridLayout,
      "col-num": parseInt(_vm.colNum),
      "row-height": _vm.rowHeight,
      "is-draggable": _vm.draggable,
      "is-resizable": _vm.resizable,
      "vertical-compact": true,
      "use-css-transforms": true
    }
  }, _vm._l((_vm.layouts.gridLayout), function(item, index) {
    return _c('grid-item', {
      key: index,
      attrs: {
        "id": item.id,
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "min-w": 2,
        "min-h": 2,
        "i": item.i,
        "options": item.options,
        "model": item.model,
        "schema": item.schema,
        "is-draggable": item.model.draggable,
        "is-resizable": item.model.resizable
      }
    }, [(item.model.title) ? _c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_vm._v("\n        " + _vm._s(item.model.title) + "\n      ")]) : _vm._e(), _vm._v(" "), (item.model.bodyLeft) ? _c('div', {
      attrs: {
        "slot": "body-left"
      },
      slot: "body-left"
    }, [_vm._v("\n        " + _vm._s(item.model.bodyLeft) + "\n      ")]) : _vm._e(), _vm._v(" "), (item.model.description) ? _c('p', [_vm._v("\n        " + _vm._s(item.model.description) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', [(item.model.slots.bodyTopComponent) ? _c(item.model.slots.bodyTopComponent, {
      tag: "component",
      staticClass: "facet",
      attrs: {
        "w": item.w,
        "chart-data": item.data,
        "site": item.model.site,
        "facet-options": item.model,
        "facet-id": item.i
      }
    }) : _vm._e()], 1), _vm._v(" "), (item.model.footer) ? _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_vm._v("\n        " + _vm._s(item.model.footer) + "\n      ")]) : _vm._e()])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35f3ccd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 604
// module chunks = 0